






































































import * as dataBreakfast from '../data/data-br.json';
import * as dataLunch from '../data/data-ln.json';
import * as dataSupper from '../data/data-sp.json';
import * as dataSnack from '../data/data-snk.json';
import {Chart} from './chart/chart';
import {MenuInitializer} from './menus/init';
import '../styles/main.css';
import {Constants} from './config/constants';

import {Component, Prop, Vue} from 'vue-property-decorator';
import * as moment from 'moment';
import MealService from '@/services/MealService';


@Component
export default class DayChart extends Vue {
  private meals: any = {};
  private todInfo: any = {
    1: {
      name: 'Breakfast',
      color: '#D3BB57'
    },
    2: {
      name: 'Lunch',
      color: '#E06A33'
    },
    3: {
      name: 'Dinner',
      color: '#1D3846'
    },
    4: {
      name: 'Snacks',
      color: 'black'
    },
    5: {
      name: 'Other',
      color: 'blue'
    }
  };

  private sizeMultiplier: any = {
    's': 0.75,
    'm': 1,
    'l': 1.25
  };

  private total: any = null;
  private nutrientName: any = Constants.nutrientNameAndUnit;

  private mounted() {
    this.initChart();
  }

  private async initChart() {
    let meals: any;
    let size = 'm';
    if (this.$route.params.meal) {
      const mealId = this.$route.params.meal;
      const author = this.$route.params.author;
      size = this.$route.params.size || 'm';
      const response = await MealService.getGraphic(mealId, author);
      meals = [response.data];
    } else if (this.$route.params.meals) {
      const mealIds = this.$route.params.meals;
      const response = await MealService.getGraphics(mealIds);
      meals = response.data;
    } else if (this.$route.params.squid) {
      const mealIds = this.$route.params.squid;
      const response = await MealService.getGraphicDataBySquid(mealIds);
      meals = [response.data];
    }


    const sizeMultiplier = this.sizeMultiplier[size];
    this.meals = meals;
    this.total = this.sumMealNutrients(sizeMultiplier);
    const keys = ['id', 'THIA', 'RAE', 'RIBO', 'N-NE', 'B6', 'DFE', 'B12', 'VITC', 'D3+D2-µG', 'ATMG', 'VITK', 'PANT', 'CA', 'CU', 'FE', 'MG', 'MN', 'P', 'K', 'SE', 'ZN', 'NA', 'CHL', 'CHOL', 'CARB', 'TDF', 'PROT', 'FAT', 'TSUG', 'SaturatedFat', 'HealthyFat'];
    // if you wanted to add other RDA percentages to the chart do so below
    // keys.push('22:6n-3DHA', '20:5n-3EPA');
    for (const meal of meals) {
      meal.category = ['breakfast', 'lunch', 'dinner', 'snacks'][parseInt(meal.tod, 10) - 1];
      for (const key in meal.percentages) {

        if (keys.indexOf(key) === -1) {
          delete meal.percentages[key];
        } else {
          meal.percentages[key] *= sizeMultiplier;
        }
      }
    }

    const testData = [
      {
        data: dataBreakfast as any,
        fileName: 'data-br.json'
      }, {
        data: dataLunch as any,
        fileName: 'data-ln.json'
      }, {
        data: dataSupper as any,
        fileName: 'data-sp.json'
      },
      {
        data: dataSnack as any,
        fileName: 'data-snk.json'
      }
    ];
    const menuInitializer = new MenuInitializer(testData);
    // @ts-ignore
    const dueDate = moment().add(4, 'days').format('YYYY-MM-DD');

    // (window as any).chart && (window as any).chart.dispose();
    ((window as any).chart = new Chart(meals, dueDate, ''));

    menuInitializer.init();
  }

  private sumMealNutrients(sizeMultiplier: number) {
    const total: any = {};

    for (const meal of this.meals) {
      total.ingredientList = total.ingredientList || [];
      total.percentages = total.percentages || {};
      for (const ingredient of meal.ingredients) {
        for (const key in ingredient) {
          if (ingredient.hasOwnProperty(key)) {
            total[key] = total[key] || 0;
            total[key] += ingredient[key] * ingredient.conversion_factor * ingredient.portion_multiplier * sizeMultiplier;
          }
        }
      }
      for (const key in meal.percentages) {
        if (meal.percentages.hasOwnProperty(key)) {
          total.percentages[key] = (total.percentages[key] || 0) + (meal.percentages[key] * sizeMultiplier);
        }
      }
    }

    return total;
  }

  private toTitleCase(str: string) {
    const strArr = str.toLowerCase().split(' ');
    const final = [];

    for (const word of strArr) {
      final.push(word.charAt(0).toUpperCase() + word.slice(1));
    }

    return final.join(' ');
  }
}
